import React from 'react';

import { useGetIntegrations } from 'hooks/domain/integrations/useGetIntegrations';
import { useFeatureFlags } from 'hooks/useFeatureFlags';

interface SellersShieldStatus {
  isFeatureFlagEnabled: boolean;
  isBrokerActive: boolean;
  isUserActive: boolean;
  isLoading: boolean;
  showOnboardingDialog: boolean;
  showIntegrationInApp: boolean;
}

/**
 * Hook to determine SellersShield availability and status
 * @returns Status information about SellersShield
 */
export const useSellersShield = (): SellersShieldStatus => {
  const integrations = useGetIntegrations();
  const { isSellersShieldEnabled: isFeatureFlagEnabled } = useFeatureFlags();

  // Get SellersShield integration status
  const sellersShieldStatus = React.useMemo(() => {
    const sellersShield = integrations?.data?.sellersshield;

    const isBrokerActive = sellersShield?.brokerEnablement === 'active';
    const isUserActive = sellersShield?.userEnablement === 'active';

    const showOnboardingDialog = isFeatureFlagEnabled && isBrokerActive && !isUserActive;
    const showIntegrationInApp = isFeatureFlagEnabled && isBrokerActive && isUserActive;

    return {
      isFeatureFlagEnabled,
      isBrokerActive,
      isUserActive,
      isLoading: integrations.isLoading,
      showOnboardingDialog,
      showIntegrationInApp,
    };
  }, [integrations?.data?.sellersshield, isFeatureFlagEnabled, integrations.isLoading]);

  return sellersShieldStatus;
};
